import React, { useEffect, useState } from "react";
import "./App.css";
import cafeBar from "./assets/backgrounds/cafe-bar.jpg";
import Api from "./api";
import { Chat } from "./Chat";
import { Friend } from "./types";

let params = new URLSearchParams(window.location.search);
const SHOW_DEV_PANEL = params.get("dev");

function App() {
  const [friend, setFriend] = useState<Friend.Friend | undefined>(undefined);
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    Api.getFriend().then((friend) => setFriend(friend));
  }, []);

  return !friend ? (
    <div>Loading . . . </div>
  ) : (
    <div className="fill-parent">
      <img src={cafeBar} className="fill-parent background" alt="local" />
      <div className="fill-parent background grid">
        <div className="content-bottom">
          <img src={friend.image.url} alt="friend-img" className="friend" />
          <div className="friend-summary">
            <span className="friend-name">{friend.name}</span>
          </div>
        </div>
        <Chat text={friend.thoughts.map(({ text }) => text)} paused={paused} />
        {SHOW_DEV_PANEL && (
          <div className="dev-panel">
            <b>Dev Panel</b>
            <br />
            <br />
            <button onClick={() => setPaused(!paused)}>
              {paused ? "▶️" : "⏸"} Chat
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
